<template>
	<icone-tooltip
		v-if="exibirIcone"
		:icone="configuracao.icone"
		:texto="configuracao.texto"
		cor="grey"
		:tamanho="`${tamanhoIcone}px`"
	></icone-tooltip>
</template>

<script>
import IconeTooltip from '@/views/components/IconeTooltip.vue'

export default {
	name: 'identificacao-ampla-cota',
	components: { IconeTooltip },
	props: {
		item: {
			type: Object,
			default: null,
		},
		tamanhoIcone: {
			type: [Number, String],
			default: 16,
		},
	},
	computed: {
		exibirIcone() {
			return this.item?.ehCota || this.item?.ehAmpla
		},
		configuracao() {
			if (this.item.ehAmpla) {
				return {
					icone: 'mdi-account-group',
					texto: 'Ampla',
				}
			}

			return {
				icone: 'mdi-account',
				texto: 'Cota',
			}
		},
	},
}
</script>

<style scoped></style>
